import { render, staticRenderFns } from "./password_forgotten.vue?vue&type=template&id=2e395a05&"
import script from "./password_forgotten.vue?vue&type=script&lang=js&"
export * from "./password_forgotten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports